<template>
    <div>
        <div id="printContent">
            <div v-for="(item, index) in printList" :key="index">
                <div class="print-title">
                    <div>Quotation Form From</div>
                    <div>{{ company }}</div>
                </div>
                <div class="order-detail">
                    <div>{{ item.NeedTime ? 'DELIVER TIME：' + item.NeedTime : '' }}</div>
                    <div>
                        DATE：
                        <el-date-picker v-show="openTimeEdit" v-model="item.QTime" value-format="yyyy-MM-dd" type="date" size="small" placeholder="选择日期时间"></el-date-picker>
                        <span v-show="!openTimeEdit">{{ item.QTime }}</span>
                    </div>
                </div>
                <div class="print-table-main">
                    <div class="div-table-row">
                        <div class="div-table-cell" style="width: 20%">CLIENT</div>
                        <div class="div-table-cell" style="width: 80%">
                            <div class="cell-content">{{ item.EntpCusName }}</div>
                        </div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell" style="width: 20%">PHONE NUM</div>
                        <div class="div-table-cell" style="width: 80%"></div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell" style="width: 20%">PART NO.</div>
                        <div class="div-table-cell" style="width: 18%">DESCRIPTION</div>
                        <div class="div-table-cell" style="width: 14%">MODEL</div>
                        <div class="div-table-cell" style="width: 6%">QTY</div>
                        <div class="div-table-cell" style="width: 6%">UNIT</div>
                        <div class="div-table-cell" style="width: 12%">UNIT PRICE</div>
                        <div class="div-table-cell" style="width: 12%">SUM TOTAL</div>
                        <div class="div-table-cell" style="width: 12%">REMARK</div>
                    </div>
                    <div class="div-table-row" v-for="(AP, index) in item.DetailList" :key="index">
                        <div class="div-table-cell img-content" style="width: 20%">
                            <div v-if="AP.GoodImg">
                                <img class="goodimg" :src="AP.GoodImg" />
                            </div>
                            <div>{{ AP.APCode }}</div>
                        </div>
                        <div class="div-table-cell" style="width: 18%">{{ AP.GoodName }}</div>
                        <div class="div-table-cell" style="width: 14%">{{ AP.AutoSerise }}</div>
                        <div class="div-table-cell" style="width: 6%">{{ AP.Count }}</div>
                        <div class="div-table-cell" style="width: 6%">{{ AP.Unit }}</div>
                        <div class="div-table-cell" style="width: 12%">{{ AP.MarketPrice }}</div>
                        <div class="div-table-cell" style="width: 12%">{{ (AP.Count * AP.MarketPrice).toFixed(2) }}</div>
                        <div class="div-table-cell" style="width: 12%">{{ AP.Remark }}</div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell" style="width: 20%"></div>
                        <div class="div-table-cell" style="width: 18%"></div>
                        <div class="div-table-cell" style="width: 14%">TOTAL QTY &nbsp;</div>
                        <div class="div-table-cell" style="width: 6%">{{ allNum }}</div>
                        <div class="div-table-cell" style="width: 6%"></div>
                        <div class="div-table-cell" style="width: 12%">TOTAL &nbsp;</div>
                        <div class="div-table-cell" style="width: 12%">{{ allPrice }}</div>
                        <div class="div-table-cell" style="width: 12%"></div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell" style="width: 20%">CUSTOMER DEMAND</div>
                        <div class="div-table-cell" style="width: 80%">{{ item.Remark }}</div>
                    </div>
                </div>
                <!--    脚注    -->
                <!-- <div
          class="order-remark"
          v-show="remarkConfig.Result && !remarkEdit"
          style="margin-bottom: 20px"
        >{{remarkConfig.RValue}}</div>
        <div class="order-setContent" v-show="remarkEdit">
          <el-input type="textarea" resize="auto" rows="3" v-model="remarkConfig.RValue"></el-input>
        </div>-->
            </div>
        </div>
        <div class="dialog-footer">
            <div class="btn-left-ctn">
                <!-- <el-button
          class="btn-primary"
          @click="editConfig(1)"
          v-show="remarkConfig.Result && !remarkEdit"
        >编辑脚注</el-button>
        <el-button class="btn-primary" @click="saveConfig(1)" v-show="remarkEdit">保存脚注</el-button>-->

                <el-button class="btn-primary" @click="editConfig(2)" v-show="openTimeConfig.Result && !openTimeEdit">设置开单时间</el-button>
                <el-button class="btn-primary" @click="saveConfig(2)" v-show="openTimeEdit">保存开单时间</el-button>
            </div>
            <div class="btn-right-ctn">
                <el-button class="btn-primary" @click="printedRecord" v-print="'#printContent'">打印</el-button>
                <el-button @click="cancel()">关闭</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import html2canvas from 'html2canvas';
export default {
    name: '',
    components: {},
    props: ['printIds'],
    data() {
        return {
            remarkConfig: {},
            remarkEdit: false,
            openTimeConfig: {},
            openTimeEdit: false,
            allPrice: 0,
            allNum: 0,
            printList: [],
            company: '',
            isPrint: false
        };
    },
    mounted() {
        this.getBJOrder();
        this.getRemarkConfig();
        this.getOpenTimeConfig();
    },
    methods: {
        printedRecord() {
            this.$util
                .printedRecord(
                    {
                        OrderId: this.printIds[0],
                        Type: 13
                    },
                    true
                )
                .then(res => {
                    this.isPrint = true;
                });
        },
        getRemarkConfig() {
            this.$util.getSysConfig('dybjsm').then(data => {
                this.remarkConfig = data;
            });
        },
        getOpenTimeConfig() {
            this.$util.getSysConfig('dybjsj').then(data => {
                this.openTimeConfig = data;
            });
        },
        editConfig(type) {
            if (type == 1) {
                this.remarkEdit = true;
            } else if (type == 2) {
                this.openTimeEdit = true;
            }
        },
        saveConfig(type) {
            if (type == 1) {
                // this.remarkEdit = false;
                // this.$util.setSysConfigValue(
                //   this.remarkConfig.Id,
                //   this.remarkConfig.RValue
                // );
            } else if (type == 2) {
                this.openTimeEdit = false;
            }
        },
        cancel() {
            this.$emit('closeDialog', this.isPrint);
        },
        getBJOrder() {
            this.$util
                .axiosGet({
                    url: '/api/EntpQuotationOrder/GetQuotationOrderEng',
                    data: {
                        QuoteId: this.printIds[0],
                        EntpId: this.$util.getLocalStorage('userMsg').EntpId
                    }
                })
                .then(res => {
                    let _allNum = 0;
                    let _allPrice = 0;
                    let data = res.data;
                    let DetailList = data.DetailList;
                    for (let i = 0; i < DetailList.length; i++) {
                        _allNum += Number(DetailList[i].Count);
                        _allPrice += DetailList[i].Count * DetailList[i].MarketPrice;
                    }
                    this.allNum = _allNum;
                    this.allPrice = _allPrice;
                    this.printList.push(res.data);
                    this.company = data.EntpEngName;
                });
        }
    }
};
</script>
<style lang="less" scoped>
.order-detail {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-left: 10px;
    margin-right: 10px;
    padding: 15px 0;
    color: #000;
}
.order-setContent {
    margin-bottom: 20px;
}
.company {
    padding: 20px 0;
    color: #000;
}
.print-title {
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    color: #000;
}
.dialog-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.print-table-main {
    width: 792px;
    margin-left: 1px;
    margin-bottom: 20px;
    .div-table-row {
        border-color: black;
    }

    .div-table-cell {
        // overflow: hidden;
        // text-overflow: ellipsis;
        // white-space: nowrap;
        // height: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        // line-height: 25px;
        padding: 5px;
        border-top: 1px solid #000;
        border-right: 1px solid #000;
        border-bottom: 1px solid #000;
        color: #000;
    }
    .img-content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-content: center;
    }
    .goodimg {
        height: 80px;
        width: 130px;
        margin-top: 10px;
    }
    .cell-content {
        width: 100%;
    }
}
</style>
